import { useCallback, useRef } from 'react'

const SWIPE_THRESHOLD_PX = 60
const HORIZONTAL_DOMINANCE_RATIO = 2

export function useSwipeBack(onBack, enabled = true) {
  const startRef = useRef(null)

  const onTouchStart = useCallback((event) => {
    if (!enabled) {
      return
    }

    const touch = event.touches[0]
    if (!touch) {
      startRef.current = null
      return
    }

    // Не перехватываем жесты, начатые на горизонтальных контролах (слайдер срока аренды):
    // <input type="range"> сам реагирует на горизонтальное движение и иначе ложно
    // триггерит swipe-back. Игнор — только по точке СТАРТА жеста, свайп в остальных
    // зонах экрана продолжает работать.
    const target = event.target
    if (
      target
      && typeof target.closest === 'function'
      && target.closest('input[type="range"], [data-no-swipe-back]')
    ) {
      startRef.current = null
      return
    }

    startRef.current = {
      x: touch.clientX,
      y: touch.clientY,
    }
  }, [enabled])

  const onTouchEnd = useCallback((event) => {
    if (!enabled || !startRef.current) {
      return
    }

    const touch = event.changedTouches[0]
    const start = startRef.current
    startRef.current = null

    if (!touch) {
      return
    }

    const deltaX = touch.clientX - start.x
    const deltaY = touch.clientY - start.y
    const absDeltaX = Math.abs(deltaX)
    const absDeltaY = Math.abs(deltaY)

    if (
      deltaX > 0
      && deltaX >= SWIPE_THRESHOLD_PX
      && absDeltaX > absDeltaY * HORIZONTAL_DOMINANCE_RATIO
    ) {
      onBack?.()
    }
  }, [enabled, onBack])

  const onTouchCancel = useCallback(() => {
    startRef.current = null
  }, [])

  return {
    onTouchStart,
    onTouchEnd,
    onTouchCancel,
  }
}
